import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

export interface CloseButtonProps {
  onPress: () => void;
  testID?: string;
}

export function CloseButton({ onPress, testID }: CloseButtonProps) {
  return (
    <IconButton
      aria-label="Close"
      icon={<CloseIcon boxSize="12px" />}
      onClick={onPress}
      variant="ghost"
      w="44px"
      h="44px"
      minW="44px"
      borderRadius="full"
      color="onboarding.plum"
      _hover={{ bg: 'blackAlpha.50' }}
      data-testid={testID}
    />
  );
}

export default CloseButton;
